import script from "./POC-Fish-Crawler.vue?vue&type=script&setup=true&lang=js"
export * from "./POC-Fish-Crawler.vue?vue&type=script&setup=true&lang=js"

import "./POC-Fish-Crawler.vue?vue&type=style&index=0&id=44b5bf06&lang=scss&scoped=true"
import "./POC-Fish-Crawler.vue?vue&type=style&index=1&id=44b5bf06&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44b5bf06"]])

export default __exports__